export default __webpack_public_path__ + "static/media/butcher5.7dfed03e.png";